import {Injectable, inject} from '@angular/core';
import {Subject} from 'rxjs';
import {BrowserStorageService} from '@services/browser-storage/browser-storage.service';

const SEARCH_TERM_KEY = 'searchTerm' as const;

@Injectable({
  providedIn: 'root'
})
export class BriefViewService {
  private readonly _localStorageService = inject(BrowserStorageService);

  shouldResetSearchTerm = new Subject<string>();

  saveSearchTerm(term: string) {
    this._localStorageService.set(SEARCH_TERM_KEY, term);
  }

  getSearchTerm(): string {
    return this._localStorageService.get(SEARCH_TERM_KEY) || '';
  }

  resetSearchTerm() {
    this._localStorageService.remove(SEARCH_TERM_KEY);
    this.shouldResetSearchTerm.next('');
  }
}
